import { Injectable } from '@angular/core';
import {
  collection,
  collectionData,
  doc,
  onSnapshot,
  query,
  where
} from '@angular/fire/firestore';

/**
 * Servicio que define las funciones de Firestore de Firebase.
 * Esta clase facilita el mocking de las funciones de Firestore en pruebas unitarias.
 */
@Injectable({
  providedIn: 'root'
})
export class AppDatabaseDefinitionService {
  /**
   * Devuelve la llamada a la función de Firebase para obtener un documento.
   * @returns {Function} Función que recibe una referencia y devuelve un documento.
   */
  public get doc() {
    return doc;
  }

  /**
   * Devuelve la llamada a la función de Firebase para obtener una colección.
   * @returns {Function} Función que recibe una referencia y devuelve una colección.
   */
  public get collection() {
    return collection;
  }

  /**
   * Devuelve la llamada a la función de Firebase para obtener una colección de datos.
   * @returns {Function} Función que recibe una referencia y devuelve una colección de datos.
   */
  public get collectionData() {
    return collectionData;
  }

  /**
   * Devuelve la llamada a la función de Firebase para escuchar cambios en tiempo real.
   * @returns {Function} Función que recibe una referencia y devuelve un observable de cambios.
   */
  public get onSnapshot() {
    return onSnapshot;
  }

  /**
   * Devuelve la llamada a la función de Firebase para crear una consulta.
   * @returns {Function} Función que recibe una colección y devuelve una consulta.
   */
  public get query() {
    return query;
  }

  /**
   * Devuelve la llamada a la función de Firebase para aplicar filtros a una consulta.
   * @returns {Function} Función que recibe una consulta y devuelve una consulta filtrada.
   */
  public get where() {
    return where;
  }
}